"use client";

import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useRef } from "react";

import Autoplay from "embla-carousel-autoplay";
import Fade from "embla-carousel-fade";

import { Button } from "@/components";
import { Brand } from "@/core/Brand";
import styles from "@/styles/components/embla-banners.module.scss";
import ClassNames from "embla-carousel-class-names";
import { useTranslations } from "next-intl";
import NextImage from "next/image";
import { DotButton, useDotButton } from "./Highlights/EmblaCarouselDotButton";

const Canvas = ({ imageUrl }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const img = new Image();

    img.onload = function () {
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      context.drawImage(img, 0, 0, canvas.width, canvas.height);
    };

    img.src = imageUrl;
  }, [imageUrl]);

  return <canvas ref={canvasRef} />;
};

const Banner = ({ banner, onClick }) => {
  return (
    <div
      className={styles.emblaSlide}
      onClick={() => onClick && onClick(banner)}
    >
      <div className={styles.highlight}>
        <div className={styles.picture}>
          <Canvas
            imageUrl={`${process.env.NEXT_PUBLIC_CDN_ASSETS}/${banner?.image}`}
          />
        </div>
      </div>
    </div>
  );
};

const Banners = ({
  banners,
  onClose,
  startPressedCounter,
  stopPressedCounter,
  onClick,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      axis: "x",
      loop: true,
      slidesToScroll: 1,
    },
    [Autoplay({ playOnInit: true, delay: 6000 }), ClassNames()]
  );

  const { selectedIndex, scrollSnaps } = useDotButton(emblaApi);

  const t = useTranslations();

  if (banners?.length === 0 || !banners) {
    return;
  }

  return (
    <div className={styles.embla}>
      <div
        className={styles.brandLogo}
        onMouseDown={startPressedCounter}
        onTouchStart={startPressedCounter}
        onTouchEnd={stopPressedCounter}
        onMouseUp={stopPressedCounter}
        onMouseLeave={stopPressedCounter}
      >
        <NextImage src={Brand.avatar} width={100} height={100} alt="Olga" />
      </div>

      <div className={styles.emblaViewport} ref={emblaRef}>
        <div className={styles.emblaContainer} id="banners">
          {banners?.map((banner, _) => {
            return (
              <Banner banner={banner} key={banner?.id} onClick={onClick} />
            );
          })}
        </div>
      </div>

      <div className={styles.start}>
        <Button onClick={onClose}>{t("tapToStart")}</Button>
      </div>

      <div className={styles.dots}>
        {scrollSnaps.map((_, index) => (
          <DotButton
            key={index}
            className={`${styles.dot}`.concat(
              index === selectedIndex ? ` ${styles.selected}` : ""
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default Banners;
